export class ItemQuoteOptions {
    constructor(optionId, quantity) {
        this.optionId = optionId;
        this.quantity = quantity;
    }
}